module.exports = __webpack_public_path__ + "media/images/flags/sv-f33a701da1f6d083c4809c11135b6649.svg";